










import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import OrganisationEdit from '@/components/OrganisationEdit.vue';
import { Action, Getter } from 'vuex-class';

@Component({
  components: {
    OrganisationEdit,
  },
})
export default class OrganisationDetails extends Vue {
  @Getter private activeOrganisation!: any;
  @Getter private hasPermission: any;

}
